<template>
    <div class="netPanel">
			<el-form :model="netValue" :rules="rules" ref="editNetForm" label-width="110px" size="small" :inline="true">
				<el-form-item label="净值时间" prop="valueTime" >
					<el-date-picker
						align="right"
						type="date"
						placeholder="净值时间"
						v-model="netValue.valueTime"
						value-format="yyyy-MM-dd"
						style="width: 280px;"></el-date-picker>
				</el-form-item>
				<el-form-item label="资产份额" prop="totalPortion" >
					<el-input-number v-model="netValue.totalPortion" :precision="2"  :step="1" :min="0" style="width: 280px;"></el-input-number>
				</el-form-item>
				<el-form-item label="资产净值" prop="totalAmount" >
					<el-input-number v-model="netValue.totalAmount" :precision="4"  :step="1" :min="0" style="width: 280px;"></el-input-number>
				</el-form-item>
				<el-form-item label="单位净值" prop="netValue" >
					<el-input-number v-model="netValue.netValue" :precision="4"  :step="0.0001" :min="0" style="width: 280px;"></el-input-number>
				</el-form-item>
				<el-form-item label="累计单位净值" prop="totalNetValue" >
					<el-input-number v-model="netValue.totalNetValue" :precision="4"  :step="0.0001" :min="0" style="width: 280px;"></el-input-number>
				</el-form-item>
				<el-form-item class="one-row-label" label="分类信息" prop="items" style="display: block;height: 30px;width:100%;">
					<span></span>
				</el-form-item>
				<div style="padding: 0 20px;margin-top: -10px;">
					<el-table id="el-table-cus" size="mini" :data="netValue.items"  header-cell-class-name="table_header" row-key="id" :border="true">
						<el-table-column prop="name" label="分级名称" :width="80">
						</el-table-column>
						<el-table-column prop="totalPortion" label="资产份额">
							<template slot-scope="scope">
								<el-input-number size="mini" v-model="scope.row.totalPortion" :precision="2" :step="1" :min="0" style="width:150px;"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="totalAmount" label="资产净值">
							<template slot-scope="scope">
								<el-input-number size="mini"  v-model="scope.row.totalAmount" :precision="4" :step="1" :min="0" style="width:150px;"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="netValue" label="单位净值">
							<template slot-scope="scope">
								<el-input-number size="mini"  v-model="scope.row.netValue" :precision="4" :step="0.0001" :min="0" style="width:150px;"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="totalNetValue" label="累计单位净值">
							<template slot-scope="scope">
								<el-input-number size="mini"  v-model="scope.row.totalNetValue" :precision="4" :step="0.0001" :min="0" style="width:150px;"></el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</el-form>
			<div style="text-align: right;margin-top: 10px;margin-right: 20px;">
				<el-button size="small" type="primary" @click="submit()">确 定</el-button>
			</div>
		</div>
</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";

    export default {
        name: "edit-net-panel.vue",
			data:function () {
				var netItemValidate = function (rule, categoryList, callback) {
					var validate  = true;
					for(var i=0;i<categoryList.length;i++){
						var category = categoryList[i];
						if(category.netValue == null ){
							validate = false;
							break;
						}
						if(category.totalAmount == null){
							validate = false;
							break;
						}
						if(category.totalPortion == null){
							validate = false;
							break;
						}
					}
					if(validate){
						//去掉error
						var className = document.getElementById("el-table-cus").className;
						className.replaceAll("error","");
						document.getElementById("el-table-cus").className = className;
						callback();

					}else{
						//添加error
						var className = document.getElementById("el-table-cus").className;
						className+=" error";
						document.getElementById("el-table-cus").className = className;
						callback(new Error("资产数据填写不正确"));

					}
				};
				return {
					pickerOptions: {
						disabledDate(time) {
							return time.getTime() > Date.now();
						},
						shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						}, {
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						}, {
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						}]
					},
					rules: {
						valueTime: [
							{ required: true, message: '请输入净值时间', trigger: 'blur' }
						],
						netValue: [
							{ required: true, message: '请输入单位净值', trigger: 'blur' },
							{ type:'number', message: '必须为数字', trigger: 'blur' }
						],
						totalNetValue: [
							{ required: true, message: '请输入累计单位净值', trigger: 'blur' },
							{ type:'number', message: '必须为数字', trigger: 'blur' }
						],
						totalAmount: [
							{ required: true, message: '请输入资产净值', trigger: 'blur' },
							{ type:'number', message: '必须为数字', trigger: 'blur' }
						],
						totalPortion: [
							{ required: true, message: '请输入资产份额', trigger: 'blur' },
							{ type:'number', message: '必须为数字', trigger: 'blur' }
						],
						items: [
							{ type:'array',required: true,validator: netItemValidate}
						]
					},
					operating:false,
					changed:false,
				}
			},
			props:{
				netValue:{},
				product:{}
			},
			watch:{
				netValue:{
					handler:function(){
						if(this.firstchange){
							this.changed = true;
						}
						this.firstchange = true;
					},
					deep:true
				}
			},
			created:function () {
			},
			methods:{
				submit(){
					this.$refs.editNetForm.validate((valid) => {
						if (valid) {
							this.operating = true;
							axios({
								method: 'post',
								url:config.host+'/backend/product/value/update.json',
								data:this.netValue
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '保存成功',
										type: 'success'
									});
									this.$emit('updatesuccess');
								}else{
									this.$alert(response.data.emsg, '保存失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '保存失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				},
			}
    }
</script>

<style scoped>
	.one-row-label>>>.el-form-item__label{
		text-align: right;
		width: 110px;
	}

	.one-row-label>>>.el-form-item__error{
		width: 400px;
		line-height: 28px;
	}

	.netPanel>>>.el-table .cell{
		padding: 0 5px;
		line-height: 20px;
	}

	.netPanel>>>.error{
		border: 1px solid red !important;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/product/EditNetPanel.vue